



























































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { METHODS, PAYMENT_GATEWAYS } from '@/constants/payment';
import ServiceOrderCreateOrderReviewTable from './Create/ServiceOrderCreateOrderReviewTable.vue';

@Component({
  components: {
    ServiceOrderCreateOrderReviewTable,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      candidate: 'candidate',
    }),
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderCreate extends Vue {
  @Prop({ default: true }) readonly redirectAfterSubmit!: boolean;
  @Prop() requestedOrderDetails!: {
    object_id: string | undefined;
    required_quantity: number;
    current_quantity: number;
  }[];

  currentStep = 0;
  isMounted = false;
  isLoading = false;
  isCalculatePriceFinished = false;
  isInvoiceInsuffientCredit = false;

  candidate!: Model;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;
  orderDetails: {
    object_id: string | undefined;
    quantity: number;
    current_quantity: number;
  }[] = [{ object_id: '', quantity: 0, current_quantity: 0 }];
  serviceItems!: Model[];
  serviceItemTotalAvailableQuantity!: [];
  paymentMethods = METHODS;
  paymentGateways = PAYMENT_GATEWAYS;
  paymentMethod = this.paymentMethods.PREPAID.key;
  paymentGateway = '';
  canStep1 = false;
  isApiFetch = {
    isApiFetchServiceItemsFinished: false,
    isApiFetchServiceItemTotalAvailableQuantityFinished: false,
  };
  showAdditionalService = false;

  beforeMount() {
    this.$store.commit('ServiceOrder/CLEAR_STATE');
    this.$store.commit('ServicePayment/CLEAR_STATE');

    this.$store.dispatch('ServiceItem/fetchList').then((response) => {
      this.serviceItems = response.data.data;
      this.isApiFetch['isApiFetchServiceItemsFinished'] = true;
    });

    this.$store
      .dispatch(
        'Candidate/serviceItemTotalAvailableQuantity',
        this.candidate.object_id
      )
      .then((response) => {
        this.serviceItemTotalAvailableQuantity = response.data.data;
        this.isApiFetch[
          'isApiFetchServiceItemTotalAvailableQuantityFinished'
        ] = true;
      });
  }

  get steps() {
    return [
      {
        title: 'Step 1',
        subtitle: 'Additional Services',
        canProceed: () => {
          return this.canStep1;
        },
      },
      {
        title: 'Step 2',
        subtitle: 'Order Details',
        canProceed: () => {
          return this.canStep1;
        },
      },
    ];
  }

  placeOrder() {
    this.isLoading = true;
    const serviceOrder = {
      candidate_oid: this.candidate.object_id,
      payment_method: this.paymentMethod,
      order_details: this.orderDetails,
    };
    this.$store.dispatch('ServiceOrder/create', serviceOrder).then(() => {
      if (this.activeServiceOrder.object_id) {
        if (this.redirectAfterSubmit) {
          this.$router.push({
            name: 'candidate-service-order-read',
            params: {
              serviceOrderOid: this.activeServiceOrder.object_id,
            },
          });
        } else {
          this.$emit('submitted');
        }
      }
      this.isLoading = false;
    });
  }

  // afterPay(servicePayment, result) {
  //   this.$emit("paid", {
  //     servicePayment,
  //     result
  //   })
  //   if (this.redirectAfterPay && this.activeServiceOrder.object_id) {
  //     this.$router.push({
  //       name: "candidate-service-order-read",
  //       params: {
  //         serviceOrderOid: this.activeServiceOrder.object_id
  //       }
  //     })
  //   }
  // }

  stepChange(index) {
    if (index == 1) {
      // pre calculate price
      this.isCalculatePriceFinished = false;
      const payload = {
        order_details: this.orderDetails,
      };
      this.$store
        .dispatch('ServicePayment/preCalculatePrice', payload)
        .then(() => {
          this.isCalculatePriceFinished = true;
        });
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (!isFinished) {
        return;
      }

      if (isFinished) {
        this.orderDetails = this.serviceItems.map((serviceItem) => {
          let quantity = 0;
          if (this.requestedOrderDetails) {
            const item = this.requestedOrderDetails.find(
              ({ object_id }) => object_id === serviceItem.object_id
            );
            if (item) {
              quantity = item.required_quantity;
            }
          }
          return {
            object_id: serviceItem.object_id,
            quantity: quantity,
            current_quantity:
              serviceItem.object_id &&
              this.serviceItemTotalAvailableQuantity[serviceItem.object_id]
                ? parseInt(
                    this.serviceItemTotalAvailableQuantity[
                      serviceItem.object_id
                    ]
                  )
                : 0,
          };
        });

        this.isMounted = true;
      }
    }
  }

  @Watch('orderDetails', { deep: true })
  watchOrderDetails(v) {
    this.canStep1 = false;
    for (const key in v) {
      if (parseInt(v[key]['quantity']) > 0) {
        this.canStep1 = true;
      }
    }
  }

  itemMessage(i) {
    const after =
      Number(this.orderDetails[i].current_quantity) +
      Number(this.orderDetails[i].quantity);
    return (
      'Current Quantity: ' +
      this.orderDetails[i].current_quantity +
      ', After Top up: ' +
      after
    );
  }

  unitPriceDiscount(item, quantity) {
    let unitPrice = item.unit_price;
    if (item.discount_rule && item.discount_rule.length) {
      for (const discount of item.discount_rule) {
        if (Number(quantity) < discount.min_quantity) {
          continue;
        }
        unitPrice = Number(item.unit_price) * Number(discount.discount);
        break;
      }
    }

    return unitPrice;
  }

  navigate(selected, step, done) {
    this.currentStep = step;
    done();
  }
}
